<template>
    <div v-if="isShow" :style="domStyle"  class="fvWaterPolo">
        <div v-if="isEnable" :style="enableStyle"></div>
       
    </div>
</template>

<style>
/***
    此处Loading的css样式
*/
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
</style>

<script>
import 'echarts-liquidfill/src/liquidFill';
export default {
    name : "fvWaterPolo",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        //loading样式
        this.loadingStyle = {
            position : "absolute",
            fontSize: "15px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5",
            zIndex:1000
        }
        this.oldTime="";
        //如果不添加点的话，保证程序不崩溃
        if(this.store == null){
            this.store = [];
        }
        this.newStore = this.store.slice();
        this.newStartTime = this.startTime;
        this.newEndTime = this.endTime;
        this.newTimeStep  = this.timeStep;
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    mounted : function(){
        //是否显示悬浮框
        this.initOption();    //创建曲线（无数据）
        this.UpDateData();
    },
    data : function(){
        return {
            isProgress : false,
            
            setup : false,//点选择
            setupTow : false,
            //是否显示
            isShow : true,
            isEnable : false,
            //组件名称
            name : "newCommunication",
            loadingStyle:{},
            //开启实自适应
            // ScaleMark:0,
            //曲线历史实时点最大值最小值
            curveMaxNum : 0,
            curveMiniNum : 0,
            dataAll : [],
            minimumScale:0,
            largestScale:100,
            water : undefined,
            fontA:"",
            weight:"",
            isDraw : false,
            startTimeOut : false,
            endTimeOut : false,
            //警戒线勾选以及值
            upperLimit : "",
            upperShow : 0,
            lowerLimit : "",
            lowerShow : 0,
            //弹窗列表form表单
            //警戒线上下限起始值勾选input框显示隐藏
            ofNumber:0,
            //曲线线型
            linetype:"liquidFill",
            isloading:false,
            //标记使用点击，还是悬浮
            triggerOn:"mousemove", //mousemove|click ,mousemove
            isRenovate:true, //刷新按钮,
            viewVersion:"10.0.3.3"
        }
    },
    methods : {

        //     参数：src ：外部属性（对象）
        //     作用：混淆属性
        // */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            if(this.isDraw == false) return;
            this.ofNumber++;
            // var newTime= new Date().getTime();
            // var time_sec = parseInt(Math.floor(newTime/1000));
            // var dataTime = parseInt(Math.floor(this.tempDataTime/1000));
            if(this.ofNumber%this.timeStep==0){
                this.revoeLine();
            }
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            // this.setMultilingual();
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = 0;
            } 

            var scaleY = parseFloat(window.innerHeight-30) / parseFloat(this.$store.state.system.$.screenHeight);
            this.domStyle.left = parseInt(((this.x + this.x * this.frameScaleX)* (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt(((this.y +titleHeight)* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height =  parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";

            //loading自适应
            this.loadingStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.loadingStyle.height =  parseInt((this.height-scaleObj.titleHeight) * (scaleY + scaleObj.zoom)) + "px";
            //加上2个边框
            this.chart.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            //this.chart.style.height = parseInt((this.height-scaleObj.titleHeight) * (scaleY + scaleObj.zoom)) + "px";
            this.chart.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom))+ "px";
            this.water.resize();



        },
        /*
            多语言title
        */
   
        //请求实时
        initRealTimeData(){
            //this.data = [];
            var now = new Date();
            this.tempDataTime = now.getTime();
            for(var i = 0; i < this.store.length; i++){
                var arr = new Array();
                //用当前的时间长度除以当前的步长
                for(var j = 0; j < this.timeStep+1 ; j++){
                    arr.unshift(["-"]);
                }
                this.data.push(arr);
            }
        },

        /**
         * 作用：初始化曲线
         */
        initOption(){
            //判断是否是定制y轴区间， 显示刷新按钮
            //定制功能是鼠标悬浮不是点击
           if (!this.fontStyle && !this.fontWeight) {
                this.fontA="normal";this.weight="normal";
            } else if (!this.fontStyle && this.fontWeight) {
                this.fontA="normal";
                this.weight="bold";
            } else if (this.fontStyle && !this.fontWeight) {
                this.fontA="italic";
                this.weight="normal";
            } else if (this.fontStyle && this.fontWeight) {
                this.fontA="italic";
                this.weight="bold";
            }
            let num = 1;
            if(this.backgroundColor=="rgba(0, 0, 0, 0)"){
                num = 0;
                this.backgroundColor ="rgb(0,0,0)";
            }
            let backColor=this.backgroundColor;
            backColor=backColor.replace("rgb(","");
            backColor=backColor.replace(")","");
            let arr=backColor.split(",");
            let backgroundColor=`rgba(${parseFloat(arr[0])},${parseFloat(arr[1])},${parseFloat(arr[2])},${num})`;
            let resultColor=`rgba(${parseFloat(arr[0])+4},${parseFloat(arr[1])+1},${parseFloat(arr[2])+2},${num})`;
            this.originalTitleName=this.title;
            var resText = this.fvSystemApi.getResource(this.originalTitleName);
            this.titleSize = this.titleSize ? this.titleSize :20;
             this.option = {
                backgroundColor:new this.$echarts.graphic.RadialGradient(0.3, 0.3, 0.8, [
                    {
                        offset: 0,
                        color:backgroundColor
                    },
                    {
                        offset: 1,
                        color: resultColor
                    },
                ]),//设置背景色 curveBackgroundColor
                title: [{
                        text: resText ? resText : this.originalTitleName,
                        left: this.titleLocation,
                        textStyle:{
                            fontSize: this.titleSize,
                            fontFamily: this.fontFamily,
                            fontWeight: this.weight,
                            fontStyle:this.fontA,
                            color: this.titleColor,
                        },
                    }],
                
                // 提示框组件
                tooltip: {
                    trigger: 'item', // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
                    textStyle: {
                        color: '#fff' // 文字颜色
                    },
                    // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
                    // 水球图: {a}（系列名称），{b}（无），{c}（数值）
                    // 使用函数模板   传入的数据值 -> value: number|Array,
                    formatter: function (value) {
                        return value.seriesName + ': ' + value.data * 100
                    }
                },
                graphic: [],
                series:[],
            };
            //当曲线标题在右侧的时候 将图例的位置进行改变
            this.chart = document.createElement("div");
            this.chart.style.position = "absolute";
            // this.$el.title="";
            this.$el.appendChild(this.chart);
            this.water = this.$echarts.init(this.chart);
            this.showCurve();

        },
        showCurve(){
            //自适应历史和实时
            this.water.setOption(this.option,true);
            this.water.cycle = 0;
            this.water.resize();
            //关闭加载中
            this.$Spin.hide();
        },

        // 
        //请求实时调用
        updateRealTimeCurve(){
            this.initRealTimeData();
            this.upDateOption();
            this.showCurve();
            this.isloading = false;
        },
        isNumNan(value) {
            return  (typeof value) === 'number' && window. isNaN(value);
        },
        //回调警戒线监听

        //实例化样式  以及修改曲线颜色
        upDateOption(){
            this.option.graphic = [];
            this.option.series = [];
            let backColor=this.waterBorderColor;
            backColor=backColor.replace("rgb(","");
            backColor=backColor.replace(")","");
            let arr=backColor.split(",");
            let resultColor=`rgb(${parseFloat(arr[0])-20},${parseFloat(arr[1])-20},${parseFloat(arr[2])-20})`;
            let result1Color=`rgb(${parseFloat(arr[0])+20},${parseFloat(arr[1])+20},${parseFloat(arr[2])+20})`;
            //水球显示背景
            let waterShowBg=this.waterShowBg;
            waterShowBg=waterShowBg.replace("rgb(","");
            waterShowBg=waterShowBg.replace(")","");
            let arr1=waterShowBg.split(",");
            let resultwaterShowBg=`rgb(${parseFloat(arr1[0])-20},${parseFloat(arr1[1])-20},${parseFloat(arr1[2])-20})`;
            let result1waterShowBg=`rgb(${parseFloat(arr1[0])+20},${parseFloat(arr1[1])+20},${parseFloat(arr1[2])+20})`;
            //水球未显示背景
            let waterHiddenBg=this.waterHiddenBg;
            waterHiddenBg=waterHiddenBg.replace("rgb(","");
            waterHiddenBg=waterHiddenBg.replace(")","");
            let arr2=waterHiddenBg.split(",");
            let resultwaterHiddenBg=`rgb(${parseFloat(arr2[0])-30},${parseFloat(arr2[1])-30},${parseFloat(arr2[2])-30})`;
            let result1waterHiddenBg=`rgb(${parseFloat(arr2[0])+10},${parseFloat(arr2[1])+10},${parseFloat(arr2[2])+10})`;
            let that=this;
            // this.option.title=[];
            let center;
            for (var a in this.store) {
                center = 100 / (2 + Number(a));
            }

           // this.water = this.$echarts.init(this.chart);
           //没有曲线 多y轴必须存有一个y轴对象
            for(var i = 0;i < this.store.length; i++){
                var nameLen = this.store[i].name.length;
                if(nameLen< this.store[i].name.length){
                    var nameLen = this.store[i].name.length;
                }
                for (const key in this.data[i]) {
                    let num = this.data[i][key][0]
                    let isNumA = this.isNumNan(num)
                    if(!isNumA){
                        this.data[i][key]=[0]
                    }
                }
                this.option.series.push({
                        type: 'liquidFill',
                        data: this.data[i],// 系列中的数据内容数组
                        name: this.store[i].name, // 系列名称，用于tooltip的显示，legend 的图例筛选
                        radius: center*1.5 + "%",
                        center: [center * Number(i + 1) + "%", "59%"],
                        // radius: '62%', // 水球图的半径
                        //     center: ['50%', '60%'], // 水球图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
                        // 水填充图的形状 circle 默认圆形  rect 圆角矩形  triangle 三角形  
                        // diamond 菱形  pin 水滴状 arrow 箭头状  还可以是svg的path
                        shape: this.shape,
                        phase: 0, // 波的相位弧度 不设置  默认自动
                        direction: 'right', // 波浪移动的速度  两个参数  left 从右往左 right 从左往右
                        outline: {
                            show: true,
                            borderDistance: this.outline, // 边框线与图表的距离 数字
                            itemStyle: {
                                borderWidth: this.border,// 边框的宽度
                                borderColor: {// 边框颜色
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0,
                                        color: this.waterBorderColor,
                                        opacity:0
                                    }, {
                                        offset: 0.5,
                                        color: resultColor,
                                        opacity:0.25
                                    }, {
                                        offset: 1,
                                        color: result1Color,
                                        opacity:1
                                    }],
                                    globalCoord: false
                                },
                                shadowBlur: this.shadowBlur,// 边框的阴影范围 一旦设置了内外都有阴影
                                shadowColor: this.shadowColor,// 边框的阴影颜色,
                            }
                        },
                        // 图形样式
                        itemStyle: {
                            color: {
                                type: 'linear',// 水球显示的背景颜色
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 1,
                                    color: this.waterShowBg,
                                    opacity:0
                                }, {
                                    offset: 0.5,
                                    color: resultwaterShowBg,
                                    opacity:0.2
                                }, {
                                    offset: 0,
                                    color: result1waterShowBg,
                                    opacity:1
                                }],
                                globalCoord: false
                            }, 
                            // opacity: 0.5, // 波浪的透明度
                            // shadowBlur: 10 // 波浪的阴影范围
                        },
                        backgroundStyle: {
                            color:{// 水球未到的背景颜色
                                type: 'linear',
                                x: 1,
                                y: 0,
                                x2: 0.5,
                                y2: 1,
                                colorStops: [{
                                    offset: 1,
                                    color: this.waterHiddenBg,
                                    opacity:0
                                }, {
                                    offset: 0.5,
                                    color: resultwaterHiddenBg,
                                    opacity:0.25
                                }, {
                                    offset: 0,
                                    color: result1waterHiddenBg,
                                    opacity:1
                                }],
                                globalCoord: false
                            }, 
                        },
                        // 图形的高亮样式
                        emphasis: {
                            itemStyle: {
                                opacity: 0.8 // 鼠标经过波浪颜色的透明度
                            }
                        },
                        // 图形上的文本标签
                        label: {
                            normal: {
                                formatter: function (value) {
                                    return (value.data * 100).toFixed(2) //+ '\n'+ '\n' + value.seriesName
                                },
                                textStyle: {
                                    fontSize: this.fontSize,
                                    fontFamily: this.fontFamily,
                                    fontWeight: this.weight,
                                    fontStyle:this.fontA,
                                    color: this.store[i].color,
                                    
                                }
                            },
                            // fontSize: 55,
                            // fontWeight: 400,
                            // color: '#fff'
                        } 
                });
                let text=function(params){
                    let str=params
                    var index = 10;
                    var newstr = '';
                    for(var i=0;i<str.length;i+=index){
                        var tmp=str.substring(i, i+index);
                        newstr+=tmp+'\n';
                    }
                    if( newstr.length > 10)
                        return  newstr.substring(0,9) + '...';
                    else
                        return newstr;
                }
                // this.option.graphic.push({
                //     type: 'group',
                //     left: center * Number(i + 1) + "%",
                //     top: '20%',
                //     children: [{
                //         type: 'text',
                //         z: 100,
                //         left: '10',
                //         top: 'middle',
                //         style: {
                //             textAlign:"left",
                //             fill: this.store[i].color,
                //             text: text(this.store[i].name),
                //             font: this.fontA+" " + this.weight+" " + this.fontSize+'px' +" "+ this.fontFamily
                //         }
                //     }]
                // })
                
                this.option.title.push({
                    text:['{a|'+text(this.store[i].name)+'}'].join(''),// this.store[i].name,
                    left: center * Number(i+1)-((i+1) *2)+ "%",
                    top: '9%',
                    textStyle: {
                        rich:{
                            a: {
                                width:10,
                                height:30,
                                overflow: "truncate",
                                ellipsis:'...',
                                fontSize: this.fontSize,
                                fontFamily: this.fontFamily,
                                fontWeight: this.weight,
                                fontStyle:this.fontA,
                                color: this.fontColor,
                        
                            }
                        },
                    }
                })
            }
            this.revoeLineOpen = false;
            this.water.setOption(this.option,true);
            this.showCurve();
        },

        revoeLine(){
            if(this.revoeLineOpen == true) return;
                var tem = new Array();
                for(var i = 0; i<this.store.length; i++){
                    if(this.store[i].tagName == "") {
                        var listNumb = undefined;
                    }else{
                        var listNumb = this.fvSystemApi.getReal(this.store[i].tagName.split("$").join(""));
                    }
                    if(listNumb){
                        listNumb = listNumb.PV
                        var isScaleMark = true;//判断第一次如果是 undefined等有值再去关闭区间y轴
                    }
                    if(this.curveMaxNum == "-"){
                        this.curveMaxNum = 0;
                    }
                    if(this.curveMiniNum == "-"){
                        this.curveMiniNum = 0;
                    }
                    if(listNumb == undefined){
                        var value = this.data[i][this.data[i].length-1];
                        listNumb = value.value[1] ;
                        var isScaleMark = false;
                        // listNumb = "-";
                    }
                    //判断实时大小值
                    if(this.curveMaxNum == 0){
                        this.curveMaxNum = listNumb;
                    }else{
                        if(listNumb > this.curveMaxNum){
                            this.curveMaxNum = listNumb;
                        }
                    }
                    //判断实时大小值
                    if(this.curveMiniNum == 0){
                        this.curveMiniNum = listNumb;
                    }else{
                        if(listNumb < this.curveMiniNum){
                            this.curveMiniNum = listNumb;
                        }
                    }
                    this.dataAll.shift();
                    this.dataAll.push(listNumb)
                    if(this.data.length > 0){
                        this.data[i].shift();
                        this.data[i].push(listNumb);
                        tem.push({
                            type: this.linetype,
                            data: [this.data[i][0]/100,this.data[i][1]/100,this.data[i][1]/100]
                        })
                    }
                }
                for (let index = 0; index < this.option.series.length; index++) {
                    const element = this.option.series[index];
                    element.data=tem[index].data;
                    
                }
                // document.write(JSON.stringify(this.option)+"<br>");
                this.water.setOption(this.option,true);
        },
        /**
         * 作用:计算平均值
         * 参数：数组
         */
     
        /**
         * 作用  请求数据 接口
         */
        UpDateData: function(name){
            //添加曲线后再次开启一次 上下+5 的y轴
            this.ScaleMark = this.isRenovate ? 2:this.ScaleMark;
            //如果请求历史数据还没请求结束不再更新数据
            if(this.isProgress == true) return;
            if(this.startTimeOut || this.endTimeOut){
                return;
            }
            //开启加载中
            this.$Spin.show();
            this.store = this.newStore.slice();
            this.startTime = this.newStartTime;
            this.endTime = this.newEndTime;
            //判断结束时间不能小于结束时间
            this.timeStep = this.newTimeStep;
            this.testingStep(this.timeStep);
            
                // this.setupTow = this.setup;
            this.data = [];
            this.updateRealTimeCurve();
            this.isDraw = true;
                
            
            //关闭加载中
            this.$Spin.hide();
        },

        //验证时间间隔
        testingStep(value){
            if(value <1){
                this.$Notice.warning({
                    title: this.$store.state.system.$.languageName == "ch" ?'警告' : 'warning',
                    desc: this.$store.state.system.$.languageName == "ch" ?'时间间隔不能小于1!' : 'The time interval cannot be less than one factorial'
                });
                return;
            }
        },
        //设置组件整体显隐
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        //设置组件是否可用
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        },
       
    },

}
</script>
<style>
/* loading背景透明 */
    .fvWaterPolo .ivu-spin-fix{
        background-color: rgba(255,255,255,0);
    }
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvWaterPolo/fvWaterPolo.vue